import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import componentWithConditionDeprecated from '@atlassian/jira-common-util-component-with-condition/src/index.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsSystem from '@atlassian/jira-navigation-apps-sidebar-global-settings-system/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalMailSettingsRoute } from '@atlassian/jira-router-routes-global-mail-settings-routes/src/globalMailSettingsRoute.tsx';
import RedirectToLegacyRouting from './common/ui/redirect/legacy-routing/index.tsx';
import GlobalMailSettings, { LazyGlobalMailSettings } from './ui/index.tsx';

export const globalMailSettingsRouteEntry = createEntry(globalMailSettingsRoute, () => ({
	group: 'global-settings',
	ufoName: 'admin.global-mail-settings',

	component: componentWithConditionDeprecated(
		() => true,
		GlobalMailSettings,
		RedirectToLegacyRouting,
	),

	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SIDEBAR_ID.GLOBAL_SYSTEM_SETTINGS,
		menuId: MENU_ID.SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsSystem,
	},

	resources: [...getNavigationResources(), navigationSidebarGlobalResource],
	forPaint: [LazyAtlassianNavigation, LazyGlobalMailSettings],
}));
